import { useContext } from "react";

import {
	SelectionContext,
	TSelectionContextType,
} from "@/contexts/SelectionContext/context";

export const useSelection = <T>(): TSelectionContextType<T> => {
	const context = useContext(SelectionContext);
	if (!context) {
		return {
			selected: new Map(),
			selectItem: () => {},
			clearSelection: () => {},
			isSelected: () => false,
			isAllSelected: () => false,
			isIndeterminate: () => false,
			selectAll: () => {},
			selectMode: false,
			setSelectMode: () => {},
		} as TSelectionContextType<T>;
	}
	return context as unknown as TSelectionContextType<T>;
};
